import { useQuery } from '@tanstack/react-query';
import { adminUserApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

export function useAdminUser(id: string) {
  return useQuery({
    queryKey: queryKeys.adminUsers.detail(id),
    queryFn: () => adminUserApi.getAdminUser(id),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 1,
  });
}
